import Profile from 'common/domain/models/profile';
import LoansUser from 'common/domain/models/loansUser';
import ERRORS from 'common/errors/formatter.errors';
import catchAndThrow from 'common/errors/error.utils';

function assembleProfile(employeeProfileInfo) {
  let profile = new Profile();
  profile.name = employeeProfileInfo.name;
  profile.userId = employeeProfileInfo.employeeId;
  profile.image = employeeProfileInfo.image;
  profile.email = employeeProfileInfo.email;

  if(employeeProfileInfo.bbvaUserId) {
    profile.bbvaUserId = employeeProfileInfo.bbvaUserId;
  }

  return profile;
}

class EmployeeDataAssembler {

  static assemble(employeeProfileInfo, data) {
    let profile;
    catchAndThrow(() => profile = assembleProfile(employeeProfileInfo), ERRORS.ASSEMBLE_PROFILE);
    let user = new LoansUser(employeeProfileInfo.employeeId, profile);
    user.modalities = data.modalities;
    user.myLoans = data.myLoans;
    return user;
  }

}

export default EmployeeDataAssembler;



// WEBPACK FOOTER //
// ./client/app/loans.module/common/employeeRepository/employeeRepository.assemblers.js